<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">システム設定</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default"
						@click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<!-- パスワード有効期限 -->
			<div class="setting_row uk-flex uk-flex-middle">
				<h1 class="setting_title">パスワード有効期限</h1>
				<input class="uk-input uk-form-width-small" type="number" min="1" max="99999" v-model="password_validity_period">&emsp;日
			</div>
			<div class="setting_row">
				<p class="uk-text-danger uk-margin-small" v-for="(error, index) in errors.password_validity_period" :key="index">{{ error }}</p>
			</div>
			<div class="uk-margin-large-top uk-text-center">
				<button class="uk-button uk-button-default" :disabled="is_click" @click="clickRegisterButton">&emsp;登&emsp;録&emsp;</button>
			</div>
			<!--/ パスワード有効期限 -->

			<!-- スタッフパスワード更新情報 -->
			<div class="setting_row uk-flex uk-flex-middle uk-margin-xlarge-top">
				<h1 class="setting_title">スタッフパスワード更新情報</h1>
				<button class="uk-button uk-button-default" :disabled="is_downloading" @click="clickDownloadButton">ダウンロード</button>
			</div>
			<!--/ スタッフパスワード更新情報 -->
		</div>
	</div>
</template>

<script>

import Role from '@/api/Role'
import CgtManageAuth from '@/api/CgtManageAuth'
import SystemSetting from '@/api/SystemSetting'

export default {
	name: 'CgtManageSystemSettingPage',
	comments: [],
	data () {
		return {
			password_validity_period: null,
			errors: {},
			is_click: false,
			is_downloading: false
		}
	},
	methods: {
		returnButton: function () {
			this.$router.push('/cgt_manage')
			location.reload()
		},
		clickLogoutButton () {
			let self = this

			let return_url = '/cgt_manage/login'

			CgtManageAuth.logout().then(function (response) {
				self.$router.push(return_url)
				location.reload()
			})
		},
		loadPasswordValidityPeriod () {
			let self = this

			SystemSetting.getPasswordValidityPeriod().then(function (response) {
				self.password_validity_period = response.data.data.password_validity_period
			}).catch(function () {
				alert('パスワード有効期限の取得に失敗しました。')
			})
		},
		clickRegisterButton () {
			let self = this

			if (self.is_click) {
				return
			}

			let params = new URLSearchParams()
			params.append('password_validity_period', self.password_validity_period == null ? '' : self.password_validity_period)

			self.is_click = true
			self.errors = {}
			SystemSetting.updatePasswordValidityPeriod(params).then(function (response) {
				self.password_validity_period = response.data.data.password_validity_period
				alert('登録が完了しました')
				self.is_click = false
			}).catch(function (error) {
				if (error.response && error.response.data.errors) {
					self.errors = error.response.data.errors
				} else {
					alert('登録処理でエラーが発生しました。')
				}
				self.is_click = false
			})
		},
		clickDownloadButton () {
			let self = this

			if (self.is_downloading) {
				return
			}

			self.is_downloading = true
			SystemSetting.downloadStaffCsv().then(function (response) {
				let blob = new Blob([response.data], { type: 'text/csv' })
				let file_name = 'スタッフパスワード更新日時_' + moment().format('YYYYMMDDHHmmss') + '.csv'

				if (window.navigator.msSaveBlob) {
					window.navigator.msSaveBlob(blob, file_name)
				} else {
					let objectURL = window.URL.createObjectURL(blob)
					let link = document.createElement('a')

					document.body.appendChild(link)

					link.href = objectURL
					link.download = file_name
					link.click()

					document.body.removeChild(link)
					window.URL.revokeObjectURL(objectURL)
				}
				self.is_downloading = false
			}).catch(function () {
				alert('ダウンロード処理でエラーが発生しました。')
				self.is_downloading = false
			})
		}
	},
	created () {
	},
	beforeMount () {
	},
	mounted () {
		let self = this

		Role.show().then(function (response) { // 権限取得
			let data = response.data

			if (data.data.is_cgt_manage != true) { // 権限が無い場合
				self.$router.push('/')
				return
			}

			self.loadPasswordValidityPeriod()
		})
	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.setting_row {
		padding-left: 15%;
	}

	// UIkit標準のh1の半分のフォントサイズ
	.setting_title {
		margin: 0 60px 0 0;
		font-size: calc(2.23125rem / 2);

		@media (min-width: 960px) {
			font-size: calc(2.625rem / 2);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/CgtManageSystemSettingPage.vue